import React from 'react'
import MaterialTable from 'material-table'
import BeenhereIcon from '@material-ui/icons/BeenhereOutlined'
import { useMutation } from '@apollo/react-hooks'
import { OFFICIALIZE_SURVEY, DESTROY_SURVEY } from './queries'
import { toast } from 'react-toastify'

function AllImportedSpreadsheetsTable(props) {
  const [destroySurvey] = useMutation(DESTROY_SURVEY)
  const [officializeSurvey] = useMutation(OFFICIALIZE_SURVEY, {
    onCompleted() {
      toast.success('Questionário selecionado com sucesso!')
    }
  })

  const columns = [
    { title: 'ID', field: 'id', type: 'numeric' },
    { title: 'Identificação do Questionário', field: 'name' },
    { title: 'Data de Importação', field: 'createdAt', type: 'date' },
    { title: 'Status', field: 'importStatus' },
    { title: 'Oficial?', field: 'official' },
  ]

  return (
    <MaterialTable
      id="teste"
      title="Questionários importados"
      columns={ columns }
      data={ props.data }
      style={{ boxShadow: 'none', width: '100%' }}
      localization={{
        header: {
          actions: 'Ações',
        },
        pagination: {
          labelRowsSelect: 'registros'
        },
        toolbar: {
          searchPlaceholder: 'Pesquisar',
        },
        body: {
          emptyDataSourceMessage: 'Sem questionários importados',
          editRow: {
            deleteText: 'Deseja realmente excluir?'
          }
        }
      }}
      editable={{ onRowDelete: (row) => destroySurvey({
        variables: {
          surveyId: row.id
        }})
      }}
      actions={ [
        {
          icon: () => <BeenhereIcon fontSize="small" />,
          tootlip: 'Clique para tornar o questionário oficial',
          onClick: (event, row) => {
            officializeSurvey({
              variables: {
                surveyId: row.id
              }
            })
          }
        }
      ] }
    />
  )
}

export default AllImportedSpreadsheetsTable
